<template>
  <side-bar
    v-show="ChannelCreateSidebar === true"
    position-right
    class="z-10 max-w25"
  >
    <div class="flex sidebar-topfixpart bg-primary justify-between p-4">
      <h2 class="h2-class font-semibold text-white">EDIT TAGS</h2>

      <feather-icon
        icon="XIcon"
        @click="closeSidebar"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <div class="p-4">
      <div class="mb-2">
        <b-form-group label="Page:">
          <b-form-select
            v-model="selectedTag.filter.categoryPage._id"
            disabled
            @change="getfiltersbycategory(selectedPageCategory)"
          >
            <b-form-select-option :value="null" disabled
              >-- Please select a Page --</b-form-select-option
            >
            <b-form-select-option
              v-for="pageCategory in pageCategories"
              :value="pageCategory._id"
              :key="pageCategory._id"
              >{{ pageCategory.name }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group>
      </div>
      <!-- <div class="mb-2">
        <b-form-group label="Filter:">
          <b-form-select v-model="selectedTag.filter" disabled>
            <b-form-select-option :value="null" disabled
              >-- Please select a Filter --</b-form-select-option
            >
            <b-form-select-option
              v-for="filter in filters"
              :value="filter._id"
              :key="filter._id"
              >{{ filter.name }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group>
      </div> -->
      <div class="mb-4">
        <p class="font-semibold text-sm mb-2">
          Tags<span class="text-danger pl-1">*</span>
        </p>
        <b-input placeholder="Enter  Tags..." v-model="selectedTag.name" />
      </div>
    </div>
    <footer class="footer-fix fixed bottom-0 w-1/4">
      <base-button
        block
        type="primary"
        class="rounded-none font-semibold"
        @click="edittags()"
        >Save</base-button
      >
    </footer>
  </side-bar>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      tags: "",
      selectedPageCategory: "",
      selectedfilter: "",
      selectedTag: {},
    };
  },
  computed: {
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filters: "filters",
    }),
    ...mapState("UI", ["ChannelCreateSidebar"]),
    ...mapState("cmstag", ["select_tag"]),
  },
  watch: {
    select_tag(val) {
      // console.log(val);
      this.selectedTag = { ...val };
    },
  },
  methods: {
    async edittags() {
      const payload = {
        tagid: this.selectedTag._id,
        name: this.selectedTag.name,
      };
      if (this.selectedTag.name.trim() !== "") {
        await this.$store.dispatch("cmstag/editTag", payload);

        this.$store.commit("UI/TOGGLE_CHANNEL_CREATE_SIDEBAR", false);
        //this.$router.push({ name: "admin-tag" }).catch(() => {});
        //this.$router.go();
        //this.$router.reload();
        this.$swal.fire({
          text: "Tag successfully updated",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      } else {
        this.$swal.fire({
          icon: "info",
          text: "Please enter tag name!",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
      let payload2 = {
        offset: (this.currentPage - 1) * 5,
        limit: 5,
      };
      let tags = await this.$store.dispatch("cmstag/getTags", payload2);
      // window.location.reload();
    },
    closeSidebar() {
      this.$store.commit("UI/TOGGLE_CHANNEL_CREATE_SIDEBAR", false);
    },

    async getfiltersbycategory(payload) {
      await this.$store.dispatch("cms/getfilterbycategory", {
        categoryPage: payload._id,
      });
    },
    // handleClick(name) {
    //   this.$router.push({ name: name });
    // },
  },
};
</script>
